import { ActivePageStatus, NAME, PageInformation, RoutingState } from "./constants";

const getModel = (state): RoutingState => state.get(NAME);

export const getPageInfo = (state): PageInformation => getModel(state).pageInformation;
export const getCurrentQuery = (state) => getModel(state).pageInformation.query;

export const getActivePageStatus = (state): ActivePageStatus => getModel(state).activePageStatus;
export const getActivePageIsLoading = (state): boolean => getModel(state).activePageStatus.isLoading;
